var React = require('react');
// var onClickOutside = require('react-onclickoutside');

require('./ContextNav.css');

class ContextNav extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addedToDom: false,
      animationStarted: false
    }
    this.handleTriggerClick = this.handleTriggerClick.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.hide = this.hide.bind(this);
    this.id = '_' + Math.random().toString(36).substr(2, 9);
  }
  render() {
    if(this.props.children.length === 0) return null;

    let nav;
    if(this.state.addedToDom) {
      if(Array.isArray(this.props.children)) {
        let key = 0;
        nav = this.props.children.map((item) => {
          var clone = this.getClone(item, key)
          key++;
          return clone;
        });
      }
      else {
        nav = this.getClone(this.props.children);
      }
    }

    let hoverEvent;
    let hoverLeaveEvent;
    let clickEvent;

    if(this.props.actionEventType === 'hover') {
      hoverEvent = this.handleTriggerClick;
      hoverLeaveEvent = this.handleMouseLeave;
    }
    
      if(this.props.customClickEvent) {
        clickEvent = this.props.customClickEvent;
      }
      else {
        clickEvent = this.handleTriggerClick;
      }        
    

    let trigger;
    if(this.props.customTrigger) {
      trigger =(
        <button className="pubr-context-nav__custom-trigger" onClick={clickEvent} onMouseEnter={hoverEvent} onMouseLeave={hoverLeaveEvent} aria-expanded={this.state.addedToDom} aria-controls={this.id}>
              <span dangerouslySetInnerHTML={{ __html: this.props.customTrigger }} style={{ backgroundColor: "inherit" }}>
            </span>
        </button>
      )
    }
    else {
      trigger = (
        <button className="pubr-context-nav__trigger" onClick={clickEvent} onMouseEnter={hoverEvent} onMouseLeave={hoverLeaveEvent}>
          <svg width="18px" height="18px" viewBox="0 0 76 20" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="10"/>
            <circle cx="38" cy="10" r="10"/>
            <circle cx="66" cy="10" r="10"/>
          </svg>
        </button>
      )
    }

    let alignmentClass = this.props.align ? `pubr-context-nav--${this.props.align}` : null;

    return (
      <div className={`${this.props.className} pubr-context-nav ${alignmentClass}`} style={this.props.style}>
        {trigger}        
          <div id={this.id}>
            {this.state.addedToDom &&
            
              <nav className={this.state.animationStarted ? "pubr-context-nav__pop pubr-context-nav__pop--init" : "pubr-context-nav__pop"}>
              <div className="pubr-context-nav__pop__scrollable" style={{height:this.props.height}}>
                <ul className="pubr-context-nav__items">
                  {nav}
                </ul>
                </div>
              </nav>
              
            }
          </div>        
      </div>
    );
  }
  getClone(element, key) {
    return React.cloneElement(
        element,
        {
          // hideHandler: this.hide,
          key: key || null
        }
    );
  }
  handleClickOutside(e) {
    if(this.state.addedToDom) {
      this.hide();
    }
  }
  handleTriggerClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if(!this.state.addedToDom) {
      this.show();
    }
    else {
      this.hide();
    }
  }

  handleMouseLeave(e) {
    this.hide();
  }

  show() {
    this.setState({
      addedToDom: true,
    });
    setTimeout(() => {
      this.setState({
        animationStarted: true
      });
    }, 20);
  }

  hide() {
    this.setState({
      animationStarted: false,
    });
    setTimeout(() => {
      this.setState({
        addedToDom: false
      });
    }, 200);
  }

}

function ContextNavItem({handler, text, hideHandler, href}) {
  function handleActionClick(e) {
    e.preventDefault();
    e.stopPropagation();
    handler(e);
    // hideHandler();
  }
  let trigger;

  if(href) {
    trigger = <a href={href} className="pubr-context-nav__item__anchor" onClick={handleActionClick}>{text}</a>;
  }
  else {
    trigger = <button className="pubr-context-nav__item__action" onClick={handleActionClick}>{text}</button>;
  }
  return(
    <li className="pubr-context-nav__item">      
      {trigger}
    </li>
  )
}

module.exports = {
  ContextNav: ContextNav,
  ContextNavItem: ContextNavItem
}


// WEBPACK FOOTER //
// ./src/components/ContextNav.js